import React, { useState, useEffect } from "react";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
// Components
import Preloader from "../../../components/Preloader/Preloader";
import PDFPurchasePayable from './PDFPurchasePayable';

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const PurchasePayable = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [useridNo, setuseridNo] =  useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	
	const DownloadPdf = ( {data} ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFPurchasePayable data={data} dateFrom={format(dateRange.startDate, "MM-dd-yyyy")} dateTo={format(dateRange.endDate, "MM-dd-yyyy")} />} 
			fileName={"purchasepayable-report"}>
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'purchases_payable_report', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        })
		setPosts(result.data.data);
		setDataLoaded(true);
    }

	const data = async () => {
		//const res = await axios.get(
			//"https://www.breakingbadapi.com/api/characters"
		// 	"http://localhost/jcphq_new/public/purchases_payable_report?date_from=2015/01/01/&date_to=2016/12/01/&jc_user_id_no=DAVAOHQ"
		// );

		// process.env.REACT_APP_API_URL+'purchases_payable_report', {
        //     params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/12/01/',   
        //         jc_user_id_no: 'DAVAOHQ',  
        //     }
        // })		

		//console.log(res.data);
		//console.log(res.data.data);
	    //setPosts(res.data.data);
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "id",
			label: "id",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (rowIndex, dataIndex) => dataIndex.rowIndex + 1 
			}
		},
		{
			name: "supplier_name",
			label: "Supplier",
		},
		// {
		// 	name: "trandate",
		// 	label: "Tran Date",
		// },
		// {
		// 	name: "pono",
		// 	label: "pono",
		// 	options: {
		// 		filter: true,
		// 		sortDirection: 'desc',
		// 	},
		// },
		{
			name: "totalamt",
			label: "Total Amount",
			options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		// {
		// 	name: "rcvall",
		// 	label: "rcvall",
		// },
		// {
		// 	name: "ispaid",
		// 	label: "ispaid",
		// },
		// {
		// 	name: "iscopied",
		// 	label: "iscopied",
		// },
		// {
		// 	name: "username",
		// 	label: "username",
		// },
		// {
		// 	name: "approver",
		// 	label: "approver",
		// },
		// {
		// 	name: "status",
		// 	label: "status"
		// },
		// {
		// 	name: "branchidno",
		// 	label: "branchidno"
		// },
		// {
		// 	name: "notes",
		// 	label: "notes"
		// },
		// {
		// 	name: "freight",
		// 	label: "freight"
		// },
		// {
		// 	name: "postatus",
		// 	label: "postatus"
		// },
		// {
		// 	name: "dateapproved",
		// 	label: "dateapproved"
		// },
		// {
		// 	name: "isconverted",
		// 	label: "isconverted"
		// },
		// {
		// 	name: "convertedby",
		// 	label: "convertedby"
		// },
		// {
		// 	name: "dateconverted",
		// 	label: "dateconverted"
		// },
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'PurchasePayable.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Purchase Payable Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">

				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "25px"}}  placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={1} xl={1}> 
							<Button style ={{marginTop: "24px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid> 				
				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style={{color:"#339933"}}>
								Purchase Payable Report
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}

				<Grid
					container
					direction="row"
					justifyContent="flex-end"
					alignItems="center"
					style={{marginTop: '1rem', justifyContent: 'flex-end'}}
				>
					<div>
						<DownloadPdf 
							data 		= {posts}
						/>
					</div>
				</Grid>
			</div>
		</div>
	);
};

export default PurchasePayable;
